import React, { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Container, Card, Nav } from 'react-bootstrap';
import Header from '~/Components/Header/Header';
import TabPorTitulo from './components/TabPorTitulo';
import TabPorAtivo from './components/TabPorAtivo';

// W-0489 — Pagina Consulta de Ocorrencias de Ativos.
// Migra UConsultaOcoAtivo.pas (read-only) com 2 Tabs deep-link (?modo=titulo|ativo).
// ADR-005: pagina independente; ADR-001 RBAC; Gate 3 Q-01 B (descartar estado entre Tabs).

const MODOS_VALIDOS = ['titulo', 'ativo'];
const MODO_DEFAULT = 'titulo';

const ConsultaOcorrenciasAtivoPage = () => {
  const history = useHistory();
  const location = useLocation();

  const modoAtivo = useMemo(() => {
    const params = new URLSearchParams(location.search);
    const modo = params.get('modo');
    return MODOS_VALIDOS.indexOf(modo) >= 0 ? modo : MODO_DEFAULT;
  }, [location.search]);

  const handleSelect = (eventKey) => {
    if (!eventKey || eventKey === modoAtivo) return;
    const params = new URLSearchParams(location.search);
    params.set('modo', eventKey);
    history.replace({ pathname: location.pathname, search: `?${params.toString()}` });
  };

  return (
    <Container fluid className="p-0">
      <Header title="Consulta de Ocorrências de Ativos" />
      <Container fluid className="py-3">
        <Card>
          <Card.Header className="p-0">
            <Nav
              variant="tabs"
              activeKey={modoAtivo}
              onSelect={handleSelect}
              className="px-2 pt-2"
            >
              <Nav.Item>
                <Nav.Link eventKey="titulo">Por Título</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="ativo">Por Ativo</Nav.Link>
              </Nav.Item>
            </Nav>
          </Card.Header>
          <Card.Body className="p-0">
            {/* Q-01 B — mount/unmount via && (estado descartado ao trocar Tab). */}
            {modoAtivo === 'titulo' && <TabPorTitulo />}
            {modoAtivo === 'ativo' && <TabPorAtivo />}
          </Card.Body>
        </Card>
      </Container>
    </Container>
  );
};

export default ConsultaOcorrenciasAtivoPage;
